/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
    <header class="header">
        <section class="contenedorInformacion">
            <div class="menu-toggle mostrar-movil" :class="{ 'is-active': menuAbierto }" @click="toggleMenu">
                <div class="hamburger-inner"></div>
            </div>

            <img class="imagenLogo" src="../assets/images/ania-logo.png" @click="Dash" alt="Logo" />

            <div class="infoContainer" id="tour-profile">
                <router-link to="/Perfil" class="burgerMenu mostrar-movil">
                    <img src="../assets/svg/icono-usuario.svg" alt="Usuario" />
                    <span v-if="numeroNotificaciones > 0" class="badge-notificacion mobile">
                        {{ numeroNotificaciones }}
                    </span>
                </router-link>

                <div class="infoUsuario ocultar-movil">
                    <div class="nombreUsuario">{{ nombreCompletoUsuario }}</div>
                    <div class="locacionSistema">{{ rolUsuario }}</div>
                </div>

                <router-link to="/Perfil" class="ocultar-movil">
                    <div class="contenedorIconoUsuario">
                        <img class="imagenUsuario" src="../assets/svg/icono-usuario.svg" alt="" />
                        <span v-if="numeroNotificaciones > 0" class="badge-notificacion"
                            :class="{ parpadea: parpadear }">
                            {{ numeroNotificaciones }}
                        </span>
                    </div>
                </router-link>
            </div>
        </section>
    </header>
</template>

<script>
export default {
    data() {
        return {
            nombreUsuario: '',
            rolUsuario: '',
            nombreCompletoUsuario: '',
            numeroNotificaciones: 0,
            parpadear: false
        };
    },
    computed: {
        menuAbierto() {
            return this.$store.state.collapsedMenu;
        }
    },
    mounted() {
        this.cargarUsuario();
        this.actualizarNotificaciones();
        window.addEventListener('storage', this.actualizarNotificaciones);
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.actualizarNotificaciones);
    },
    methods: {
        toggleMenu() {
            this.$store.commit('toggleMenu');
        },
        Dash() {
            this.$router.push('./DashBoard');
        },
        cargarUsuario() {
            const userData = JSON.parse(localStorage.getItem('userData'));
            if (userData) {
                this.nombreCompletoUsuario = userData.correo;
                this.rolUsuario = userData.rol?.nombre || '';
            }
        },
        actualizarNotificaciones() {
            const notis = JSON.parse(localStorage.getItem('notificaciones')) || [];
            const cantidadAnterior = this.numeroNotificaciones;
            this.numeroNotificaciones = notis.length;

            if (this.numeroNotificaciones > cantidadAnterior) {
                this.parpadear = true;
                setTimeout(() => {
                    this.parpadear = false;
                }, 3000);
            }
        }
    }
};
</script>

<style scoped>
.header {
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1060;
    height: 85px;
    background-color: white;
    box-shadow: 0px 3px 6px #00000029;
}

.contenedorInformacion {
    user-select: none;
    height: 85px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 35px;
    background-color: white;
    position: relative;
}

.menu-toggle {
    width: 50px;
    height: 50px;
    position: relative;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1070;
}

.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
    width: 24px;
    height: 2px;
    background-color: #2a428c;
    position: absolute;
    transition: all 0.3s ease-in-out;
}

.hamburger-inner::before {
    content: "";
    top: -8px;
    left: 0;
}

.hamburger-inner::after {
    content: "";
    top: 8px;
    left: 0;
}

.menu-toggle.is-active .hamburger-inner {
    background-color: transparent;
}

.menu-toggle.is-active .hamburger-inner::before {
    transform: rotate(45deg);
    top: 0;
}

.menu-toggle.is-active .hamburger-inner::after {
    transform: rotate(-45deg);
    top: 0;
}

.imagenLogo {
    height: 45px;
    width: auto;
    cursor: pointer;
    z-index: 2;
    transition: transform 0.3s;
}

.infoContainer {
    display: flex;
    align-items: center;
}

.infoUsuario {
    display: flex;
    flex-direction: column;
}

.nombreUsuario,
.locacionSistema {
    font-size: 17px;
    text-align: right;
    margin-right: 20px;
    color: black;
}

.locacionSistema {
    font-size: 14px;
}

.contenedorIconoUsuario {
    position: relative;
    width: 48px;
    height: 48px;
    background-color: #ffffff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
}

.ocultar-movil {
    display: flex;
}

.mostrar-movil {
    display: none;
}

@media (max-width: 810px) {
    .mostrar-movil {
        display: flex;
    }

    .ocultar-movil {
        display: none;
    }

    .contenedorInformacion {
        padding: 0 15px;
    }

    .imagenLogo {
        height: 35px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .burgerMenu {
        background: white;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .burgerMenu img {
        width: 21px;
    }
}

.badge-notificacion {
    position: absolute;
    top: -6px;
    right: -12px;
    background-color: #ffffff;
    color: #691c32;
    border-radius: 999px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: bold;
    border: 1.5px solid black;
}

.parpadea {
    animation: parpadeo 1s infinite;
}

@keyframes parpadeo {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }
}
</style>